import { PriceTableContent, RowContent, priceTableData } from "constants/pricesNew";

import { useContext, useState, useRef } from "react";

import { Typography, Divider, Row } from "antd";
import { AppContext } from "App";
import PricingCheckmark from "assets/images/check.svg";
import PricingCross from "assets/images/pricing-cross.svg";
import StartButtonPricing from "components/basic/StartButtonPricing";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

const PriceTableRow = ({ text, showCheck }: RowContent) => {
    const image = showCheck ? PricingCheckmark : PricingCross;
    return <div className="vertical-center gap10">
        <img src={image} alt="checkmark or cross" width={"20px"}/>
        <Typography>{text}</Typography>
    </div>;
};

const PriceTable = ({ category, title, price, rows, isAvailable, popular, className }: PriceTableContent) => {
    const { isMobile } = useContext(AppContext);
    return (
        <div className="price-tables__card-container">

            {!isAvailable && (
                <Typography className="price-tables__availability">
                            Coming soon
                </Typography>
            )}
            <div className={isMobile ? className : (popular ? "price-tables__card-purple" : "price-tables__card")}>
                <div className="price-tables__container">
                    <div className={`horizontal-right ${popular ? "" : "price-tables__card-header"}`}>
                        {popular && <div className="price-tables__banner">{popular}</div>}
                    </div>
                    <Typography className="price-tables__category">{category}</Typography>
                    <Typography className="price-tables__title">{title}</Typography>
                    <Typography.Text className="price-tables__price">
                        {price}
                    </Typography.Text>
                </div>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px", maxWidth: "320px" }}>
                    {rows.map((row, index) => (
                        <div key={index}>
                            <PriceTableRow text={row.text} showCheck={row.showCheck} />
                            <Divider className="price-tables__rows" />
                        </div>
                    ))}
                </div>
                <StartButtonPricing
                    label="Get Started"
                    authLabel="Continue"
                    className={popular ? "shared__primary-button w100" : "shared__secondary-button w100"}
                />
            </div>

        </div>
    );
};

const PriceTables = () => {
    const { isMobile, maxWidth } = useContext(AppContext);
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef(null);

    const handleSlideChange = (swiper: any) => {
        setActiveIndex(swiper.activeIndex);
    };

    return (
        <div style={{
            display: "flex",
            justifyContent: "center",
            gap: "32px",
            padding: isMobile ? "0" : "40px",
            flexDirection: isMobile ? "column" : "row",
            maxWidth: maxWidth,
            marginBottom: isMobile ? "20px" : "",

        }}>
            {isMobile ? (
                <div style={{ maxWidth: maxWidth, padding: isMobile ? "0px" : "24px" }}>
                    <Row style={{ maxWidth: "335px", margin: "20px auto" }}>
                        <div style={{ width: "100%" }}>
                            <Swiper
                                className="price-tables__swiper"
                                modules={[Pagination]}
                                {...({ slidesPerView: 1.1 } as any)}
                                {...({ spaceBetween: 16 } as any)}
                                onSlideChange={handleSlideChange}
                                pagination={{ clickable: true }}
                                onSwiper={(swiper: any) => { swiperRef.current = swiper; }}
                            >
                                {priceTableData.map((table, index) => (
                                    <SwiperSlide key={index}>
                                        <PriceTable {...table}
                                            className={activeIndex === index ? "price-tables__card-purple" : "price-tables__card"} />
                                    </SwiperSlide>))}
                            </Swiper>
                        </div>
                    </Row>
                </div>
            ) : (
                priceTableData.map((table, index) => <PriceTable key={index} {...table} />)
            )}
        </div>
    );
};

export default PriceTables;
